import React from 'react';
import {
  Avatar,
  Box,
  Paper,
  Typography,
} from '@material-ui/core';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';

const steps = [
  {
    icon: <FolderOpenIcon fontSize="small" />,
    text: 'Select target folder',
  },
  {
    icon: <CloudUploadIcon fontSize="small" />,
    text: 'Upload Excel file',
  },
  {
    icon: <AutorenewIcon fontSize="small" />,
    text: 'Lambda validates file',
  },
  {
    icon: <CheckCircleIcon fontSize="small" />,
    text: 'Success → Input Folder',
  },
  {
    icon: <ErrorIcon fontSize="small" />,
    text: 'Failed → Error Folder',
  },
];

export const UploadHelpSection = () => (
  <Paper
    style={{
      padding: 24,
      height: '100%',
      backgroundColor: 'aliceblue',
    }}
  >
    <Typography
      variant="h6"
      gutterBottom
    >
      Processing Steps
    </Typography>

    {steps.map((step, index) => (
      <Box
        key={index}
        display="flex"
        alignItems="center"
        mb={2}
      >
        <Avatar
          style={{
            width: 36,
            height: 36,
          }}
        >
          {step.icon}
        </Avatar>

        <Typography
          variant="body2"
          style={{ marginLeft: 12 }}
        >
          {step.text}
        </Typography>
      </Box>
    ))}
  </Paper>
);